import React, {useEffect, useState} from "react";
import AddButtonFullText from "../../../buttons/AddButtonFullText";
import ActWithTeamButton from "../../../buttons/ActWithTeamButton";
import AddMemberInProject from "../../../modal/AddMemberInProject";
import ActWithTeamModal from "../../../team/act-with-team/ActWithTeamModal";
import {patchProject} from "../../../project/one-project/projectAction";
import MemberCard from "./MemberCard";
import {useDispatch, useSelector} from "react-redux";
import YesNoModal from "../../../modal/YesNoModal";
import styled from "styled-components";
import TitleSection from "../TitleSection";
import {getDateInFrench} from "../../../../utils/dateUtils";


const MyTeam = ({toggleHandler,}) => {

    const {projectHistory} = useSelector(state => state.projectHistory)
    const {id, members, pilot, copilot} = useSelector(state => state.project)
    const dispatch = useDispatch();
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openActWithTeamModal, setOpenActWithTeamModal] = useState(false);
    const [selectedMemberId, setSelectedMemberId] = useState(0)
    const [lastUpdate, setLastUpdate] = useState()
    const deleteRequest = async () => {
        await dispatch(patchProject(id, {removeMembers: [{memberId: selectedMemberId}]}))
        setOpenDeleteModal(false)
    }

    useEffect(() => {
        const lastUpdateItems = projectHistory.filter(p => p.modifiedField === "memberId" || p.modifiedField === "remove 0")
        if (lastUpdateItems.length > 0) {
            setLastUpdate(lastUpdateItems[0])
        }
    }, [projectHistory])
    const displayModal = () => {
        if(openAddModal){
            return (
                <AddMemberInProject
                projectId={id}
                setOpenModal={setOpenAddModal}
            />)
        }
        if(openActWithTeamModal){
           return (
               <ActWithTeamModal
                setOpenActWithTeamModal={setOpenActWithTeamModal}
            />)
        }
        if(openDeleteModal){
           return (
               <YesNoModal
                name={`ce membre`}
                setOpenModal={setOpenDeleteModal}
                id={id}
                handleClickYesAction={deleteRequest}
            />)
        }
    }
    return (
        <Container>
            <TitleSection
                toggleHandler={toggleHandler}
                title={"Mon équipe"}
            />
            <p> Dernière mise à jour
                : {lastUpdate ? getDateInFrench(lastUpdate.dateOfModification) : "Aucune modification"}</p>

            <AddButtonFullText
                setUpdate={setOpenAddModal}
                setId={setSelectedMemberId}
                title={"Ajouter un membre"}
            />

            <ContainerButtons>
                <ActWithTeamButton
                    setOpenActWithTeamModal={setOpenActWithTeamModal}
                />
            </ContainerButtons>
            <ContainerCockpit>
                <ContainerPilot>
                    <h2>Pilote</h2>
                    <MemberCard
                        key={pilot.id}
                        memberId={pilot.id}
                        picture={pilot.photo}
                        firstName={pilot.firstName}
                        lastName={pilot.lastName}
                        isInteractive={false}
                    />
                </ContainerPilot>
                {copilot &&
                    <ContainerPilot>
                        <h2>Copilote</h2>
                        <MemberCard
                            key={copilot.id}
                            memberId={copilot.id}
                            picture={copilot.photo}
                            firstName={copilot.firstName}
                            lastName={copilot.lastName}
                            isInteractive={false}
                        />
                    </ContainerPilot>
                }
            </ContainerCockpit>
            <p>Pour modifier pilote et copilote, passez par le paramétrage du projet (crayon dans la liste des
                projets)</p>
            <ContainerPilot>
                <h2>Membres</h2>
                <ContainerUsers>
                    {members.map(m => (
                            <MemberCard
                                key={m.id}
                                memberId={m.id}
                                picture={m.photo}
                                firstName={m.firstName}
                                lastName={m.lastName}
                                setId={setSelectedMemberId}
                                setOpenDeleteModal={setOpenDeleteModal}
                            />
                        ))
                    }
                    {members.length === 0 &&
                        <h2> Il n'y a pas encore de membres dans votre projet. </h2>}
                </ContainerUsers>
            </ContainerPilot>
            {displayModal()}
        </Container>
    )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  height: 100%;
  width: 100%;
`


const ContainerButtons = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  gap: 0.5em;
  margin: 1em 0;
  justify-content: space-around;
  @media (min-width: 600px) {
    display: flex;
    flex-direction: row;
    width: 750px;
    justify-content: space-evenly;
  }
`

const ContainerUsers = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1em;
  justify-content: center;
  padding: 0.5rem 1rem 1rem 1rem;
  @media (min-width: 900px) {
    width: 100%;
    align-items: center;
    flex-wrap: wrap;
  }
`
const ContainerCockpit = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  gap: 1rem;
`

const ContainerPilot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 1rem;
  gap: 0.5rem;


  img {
    background: white;
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    object-fit: cover;
  }
`
export default MyTeam;